define('views/content/cd_home',['require','backbone','marionette','d3','nvd3','text!templates/content/cd_home.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    var d3 = require('d3');
    var nv = require('nvd3');

    var temp = require("text!templates/content/cd_home.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-home-page',
        titleKey: 'home',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));

            this.getDistributorReports();
        },

        ui: function() {
            return {
                customerCount: '.customer-count',
                totalLicenseCount: '.total-license-count',
                activeLicenseCount: '.active-license-count',
                resellerCount: ".resellers-count",
                distributorCount: ".distributors-count",
                walletCount: '.wallet-count'
            };
        },

        showLicensesChart: function (licenseData) {
            nv.addGraph(function() {
                var chart = nv.models.discreteBarChart()
                    .x(function(d) { return d.product_name; })
                    .y(function(d) { return d.count; })
                    .showValues(true);

                chart.yAxis.tickFormat(d3.format(',f'));
                chart.xAxis.rotateLabels(-45);
                chart.valueFormat(d3.format('d'));

                d3.select(".license-chart-container svg")
                    .datum([{
                        key: App.polyglot.t('licenses'),
                        values: licenseData.sort(function (a, b) {
                            return a.count > b.count ? -1 : 1;
                        })
                    }])
                    .call(chart);

                nv.utils.windowResize(chart.update);

                return chart;
            });
        },

        getDistributorReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/cd-reports/',
                method: 'get',
                success: function (response) {
                    /*_this.ui.customerCount.text(response.customer_count + ' / 0');
                    response.active_licenses.forEach(function (entry) {
                            if (entry.product_id === 1) {
                                _this.ui.customerCount.text(response.customer_count + ' / '+entry.count);
                            }
                    });*/

                    var currencySign = response.cd_wallet && response.cd_wallet.currency;
                    var amount = response.cd_wallet && response.cd_wallet.balance;
                    var wallet = App.utils.getAmountWithCurrencySign(amount || 0, currencySign );

                    _this.ui.customerCount.text(response.customer_count);
                    _this.ui.totalLicenseCount.text(response.total_license_count);
                    _this.ui.activeLicenseCount.text(response.active_license_count);
                    _this.ui.resellerCount.text(response.reseller_count);
                    _this.ui.distributorCount.text(response.distributor_count);
                    _this.ui.walletCount.text(wallet || "0");

                    _this.showLicensesChart(response.active_licenses);
                }
            });
        }

    });
});
